import store from '@/store'

const { body } = document
const WIDTH = 1024
const RATIO = 3

export default {
  beforeMount() {
    window.addEventListener('resize', this.resizeHandler)
  },
  mounted() {
    /*const isMobile = this.isMobile()
    if (isMobile) {
      store.dispatch('toggleDevice', 'mobile')
    }*/
      this.resizeHandler()
  },
  methods: {
    isMobile() {
      const rect = body.getBoundingClientRect()
      return rect.width - RATIO < WIDTH
    },
    resizeHandler() {
      if (!document.hidden) {
        let layer = this.$route.params.layer
        if(layer && layer === 'mobile') {
            store.dispatch('toggleDevice', 'mobile')
        }else if(layer && layer === 'desktop') {
            store.dispatch('toggleDevice', 'desktop')
        }else{
            const isMobile = this.isMobile()
            //检测到不一致时，设置为对应标识
            if( isMobile != (this.$store.state.d2admin.device==='mobile') ){
                store.dispatch('toggleDevice', isMobile ? 'mobile' : 'desktop')
            }
        }
        store.dispatch('windowHeightSet',body.getBoundingClientRect().height)
      }
    }
  }
}
